import { render, staticRenderFns } from "./DefaultCarousel.vue?vue&type=template&id=3208bcae&scoped=true&"
import script from "./DefaultCarousel.vue?vue&type=script&lang=js&"
export * from "./DefaultCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3208bcae",
  null
  
)

export default component.exports